import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

const MainMemberInfo = ({ memberInfo, loader }) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Main Member Information</span>

      <Row className="mb-3 gx-sm-3 gx-2">
        <Col md={12} className="mb-md-4 mb-2">
          <div className="profile-container"></div>
        </Col>
        <Col xl={3} md={4} xs={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Main member name</Form.Label>
            <div>{memberInfo?.memberName || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formCountryCode">
            <Form.Label className="fw-bold">
              Main member mobile number
            </Form.Label>
            <div>{memberInfo?.mobile || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Main member e-mail</Form.Label>
            <div>{memberInfo?.email || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label className="fw-bold">Date of birth</Form.Label>
            <div>{memberInfo?.dob || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formNativePlace">
            <Form.Label className="fw-bold">Place of birth</Form.Label>
            <div>{memberInfo?.placeOfBirth || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label className="fw-bold">Membership Type</Form.Label>
            <div>{memberInfo?.membershipType || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label className="fw-bold">Gotra</Form.Label>
            <div>{memberInfo?.gotra || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label className="fw-bold">Gender</Form.Label>
            <div>{memberInfo?.gender || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label className="fw-bold">Belong from</Form.Label>
            <div>{memberInfo?.belongFrom || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label className="fw-bold">Reference Person</Form.Label>
            <div>{memberInfo?.referencePerson || "-"}</div>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default MainMemberInfo;
